import { usePathname } from "next/navigation";
import normalizeTechnicalMicrocredentialsPath from "../utls/normalizeTechnicalMicrocredentialsPath";

function useNormalizeTechnicalMicrocredentialsPath(courseSlug: string) {
  const pathname = usePathname();

  return normalizeTechnicalMicrocredentialsPath(courseSlug, pathname);
}

export default useNormalizeTechnicalMicrocredentialsPath;
